// extracted by mini-css-extract-plugin
export default {"info":"InfoCard_info__xnq8f","info__wrapper":"InfoCard_info__wrapper__3tIEP","info__text":"InfoCard_info__text__B1g6u"};